module.exports = __webpack_public_path__ + "img/coins.91642bb9.svg";